<template>
  <aside aria-label="Snelkoppelingen">
    <a
      href="#main"
      class="sr-only focus:not-sr-only focus:outline-none focus:ring-2 focus:ring-blue-500 rounded bg-white text-2xl focus:z-[999] focus:absolute"
    >
      <span class="px-4 pt-1 inline-block">Naar hoofdinhoud</span>
    </a>
  </aside>
</template>
